import { Directive, OnChanges, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[countTo]'
})
export class CountToDirective implements OnChanges {
  @Input() countTo: number = 100; // Target number to count to
  @Input() from: number = 0; // Starting number
  @Input() duration: number = 4; // Duration in seconds

  private readonly refreshRate: number = 30; // Interval in milliseconds for updates
  private currentValue: number = 0; // Current displayed number
  private totalSteps: number = 0; // Total number of updates
  private stepCount: number = 0; // Tracks the number of completed steps
  private incrementValue: number = 1; // Value to add on each step

  constructor(private el: ElementRef) {}

  ngOnChanges(): void {
    if (this.countTo !== undefined) {
      this.startCounting();
    }
  }

  private initialize(): void {
    // Convert duration from seconds to milliseconds
    const durationMs = this.duration * 1000;

    // Determine the total steps based on the refresh rate
    this.totalSteps = Math.ceil(durationMs / this.refreshRate);

    // Calculate the value increment per step
    this.incrementValue = (this.countTo - this.from) / this.totalSteps;

    // Set initial values
    this.currentValue = this.from;
    this.stepCount = 0;
  }

  private updateValue(): void {
    setTimeout(() => {
      this.currentValue += this.incrementValue;
      this.stepCount++;

      if (this.stepCount >= this.totalSteps) {
        // Ensure the final value is exact
        this.currentValue = this.countTo;
      }

      this.el.nativeElement.textContent = Math.round(this.currentValue);

      // Continue updating if steps remain
      if (this.stepCount < this.totalSteps) {
        this.updateValue();
      }
    }, this.refreshRate);
  }

  private startCounting(): void {
    this.initialize();
    this.updateValue();
  }
}
